import moment from 'moment-timezone';
import { getDayDiff } from 'utils/dateAndTimes/methods/methods';

const getTimesAndDatesFromShipmentCreated = ({ shipment, shouldAddDays }) => {
  const {
    pickup_time_from,
    pickup_time_to,
    dropoff_time_from,
    dropoff_time_to,
    pickup_timezone,
    dropoff_timezone,
    pickup_time_from_tz,
    pickup_time_to_tz,
    dropoff_time_from_tz,
    dropoff_time_to_tz,
  } = shipment;

  const originalPickupTimeFrom = moment(pickup_time_from)
    .tz(pickup_timezone || moment.tz.guess())
    .clone();

  const today = moment()
    .tz(pickup_timezone || moment.tz.guess())
    .clone()
    .set('hour', originalPickupTimeFrom.hour())
    .set('minute', originalPickupTimeFrom.minutes());

  let diffDays = 0;
  if (shouldAddDays) {
    const diffDaysToday = getDayDiff(today, originalPickupTimeFrom);
    diffDays = diffDaysToday + 1;
  }

  const pickupTimeFromMomment = moment(pickup_time_from)
    .tz(
      pickup_timezone ||
        pickup_time_from_tz ||
        pickup_time_to_tz ||
        moment.tz.guess()
    )
    .clone()
    .add(diffDays, 'days');
  const pickupTimeToMomment = moment(pickup_time_to)
    .tz(
      pickup_timezone ||
        pickup_time_from_tz ||
        pickup_time_to_tz ||
        moment.tz.guess()
    )
    .clone()
    .add(diffDays, 'days');
  const dropoffTimeFromMomment = moment(dropoff_time_from)
    .tz(
      dropoff_timezone ||
        dropoff_time_from_tz ||
        dropoff_time_to_tz ||
        moment.tz.guess()
    )
    .clone()
    .add(diffDays, 'days');
  const dropoffTimeToMomment = moment(dropoff_time_to)
    .tz(
      dropoff_timezone ||
        dropoff_time_from_tz ||
        dropoff_time_to_tz ||
        moment.tz.guess()
    )
    .clone()
    .add(diffDays, 'days');

  return {
    pickup_time_from: moment(pickupTimeFromMomment).format('HH:mm'),
    pickup_date_from: moment(pickupTimeFromMomment).format('YYYY-MM-DD'),
    pickup_time_to: moment(pickupTimeToMomment).format('HH:mm'),
    pickup_date_to: moment(pickupTimeToMomment).format('YYYY-MM-DD'),
    dropoff_time_from: moment(dropoffTimeFromMomment).format('HH:mm'),
    dropoff_date_from: moment(dropoffTimeFromMomment).format('YYYY-MM-DD'),
    dropoff_time_to: moment(dropoffTimeToMomment).format('HH:mm'),
    dropoff_date_to: moment(dropoffTimeToMomment).format('YYYY-MM-DD'),
    pickup_timezone:
      pickup_timezone || pickup_time_from_tz || pickup_time_to_tz,
    dropoff_timezone:
      dropoff_timezone || dropoff_time_from_tz || dropoff_time_to_tz,
  };
};

export default getTimesAndDatesFromShipmentCreated;
